export const questionnaire = {
  "questionnaire_title": "Cuestionarios",
  "questionnaire_point": "puntos",
  "questionnaire_resume": "Reanudar",
  "questionnaire_card_progress": "{{answered}} de {{total}}",
  "questionnaire_selected_count_one": "{{count}} elegida",
  "questionnaire_selected_count_many": "{{count}} elegidas",
  "questionnaire_selected_count_other": "{{count}} elegidas",
  "questionnaire_about": "Cuestionario sobre {{name}}",
  "questionnaire_questionnaire": "Preguntas",
  "questionnaire_minutes": "minutos",
  "questionnaire_continue": "Continuar",
  "questionnaire_start": "Comenzar",
  "questionnaire_finish": "Terminar",
  "questionnaire_completed": "Cuestionario terminado, ¡gracias!",
  "questionnaire_identity_conflict": "Este valor ya está siendo utilizado por otro participante. Su respuesta no se ha guardado.",
  "questionnaire_identity_unknown_external_id": "Número de expediente no reconocido — verifique el número entregado por el equipo. Su respuesta no se ha guardado."
}
